import { quickOrderPageContainerStyles } from "@insite/content-library/Widgets/QuickOrder/QuickOrderPageContainer";
import { css } from "styled-components";

quickOrderPageContainerStyles.thirdGridItem = {
    css: css`
        padding: 0;
        & [class^="HiddenStyle-sc-"] {
            display: none;
        }
    `,
};

quickOrderPageContainerStyles.bottomGridItem = {
    css: css`
        padding-top: 6px;
        width: 100%;
        max-width: 100%;
        flex-basis: 100%;
    `,
};
